import React from "react"

import moment from "moment"

class InducedItem extends React.Component {

    render() {

        const years = []
        let current = parseInt(moment().format("YYYY"))
        for (var i = 0; i < 20; i++) {
            years.push(current + i)
        }

        return (
            <div className="induced-account-detail">
                <div className="account-title">
                    <p className="account-title-number">{this.props.induced.induced.number} - {this.props.induced.induced.label}</p>
                </div>
                <div className="account-value">
                    <input ref="gain" type="number" name="gain" value={this.props.induced.gain}
                           onChange={this._handleChange.bind(this, "gain")}
                           disabled={this.props.induced.year < current && this.props.induced.year !== 0}/> €
                </div>
                <div className="account-value">
                    <input ref="loss" type="number" name="loss" value={this.props.induced.loss}
                           onChange={this._handleChange.bind(this, "loss")}
                           disabled={this.props.induced.year < current && this.props.induced.year !== 0}/> €
                </div>
                <div className="account-value">
                            <span className="select">
                                {this.props.induced.year < current && this.props.induced.year !== 0 ?
                                    <select ref="year" name="year" value={this.props.induced.year} disabled>
                                        <option value={this.props.induced.year}>{this.props.induced.year}</option>
                                    </select> :
                                    <select ref="year" name="year" value={this.props.induced.year}
                                            onChange={this._handleChange.bind(this, "year")}>
                                        {years.map(year => (
                                            <option value={year}>{year}</option>
                                        ))}
                                    </select>
                                }
                            </span>
                </div>
                <div className="account-actions">
                    <button onClick={() => {
                        this.props.onRemove(this.props.induced.id)
                    }}><i className="fa fa-trash"/></button>
                </div>
            </div>
        )
    }

    _handleChange(type, e) {
        this.props.onChange(this.props.induced.id, {
            gain: this.refs.gain.value,
            loss: this.refs.loss.value,
            year: this.refs.year.value
        })
    }

}

export default InducedItem



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/induced/item.js